export default __webpack_public_path__ + "static/media/home-icon.c84f8cad.svg";